import request from '@/request/ts-index';
var PhoneApi;
(function (PhoneApi) {
    PhoneApi["checkMobile"] = "/checkMobile";
})(PhoneApi || (PhoneApi = {}));
export const checkMobile = (params) => {
    return request.get(PhoneApi.checkMobile, {
        params: params
    });
};
